import React from 'react';
export const Paused = ({ width = 30, height = 30, ...props }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 30 30", fill: "none", ...props },
        React.createElement("circle", { cx: "15", cy: "15", r: "14.25", stroke: "currentColor", strokeWidth: "1.5" }),
        React.createElement("rect", { x: "11", y: "9", width: "2.5", height: "12", fill: "currentColor" }),
        React.createElement("rect", { x: "16.5", y: "9", width: "2.5", height: "12", fill: "currentColor" })));
};
